import React from "react";
import NestedPage from "../../components/navigation/NestedPage";
import { nestedGroups } from "../../config/navigation";

const Reports: React.FC = () => {
  const reportsGroup = nestedGroups.find(
    (group) => group.id === "reports"
  );

  if (!reportsGroup) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-gray-500">Reports group not found.</p>
      </div>
    );
  }

  return <NestedPage group={reportsGroup} />;
};

export default Reports;

